import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledButtonsWrapper, StyledSelectiveButton, StyledBadge, } from './SelectiveButton.style';
import { Icon } from '../Icon';
import { useState, useEffect } from 'react';
const variants = ['default', 'square'];
export function SelectiveButton({ value, label, isSelected, onChange, variant = 'default', size = 'Medium', badge, }) {
    const [isActive, setIsActive] = useState(isSelected);
    const onChangeHandler = (value) => {
        setIsActive(true);
        onChange(value);
    };
    useEffect(() => {
        setIsActive(isSelected);
    }, [isSelected]);
    return (_jsxs(StyledButtonsWrapper, { children: [_jsx(StyledSelectiveButton, { title: label, onClick: () => onChangeHandler(value), isActive: isActive, size: size, variant: variant, children: label }), badge && (_jsx(StyledBadge, { size: badge.icon.size, position: badge.position, onClick: badge.onClick, children: _jsx(Icon, Object.assign({}, badge.icon)) }))] }));
}
//# sourceMappingURL=SelectiveButton.js.map